import { createContext, useCallback, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";

export const PLAN_SHIPMENT_PATH = "/plan-shipment";

const PlanShipmentDrawerContext = createContext({
  embedded: false,
  closeDrawer: () => {},
});

/**
 * Wraps the detail screens when they are shown inside the desktop drawer.
 * `closeDrawer(state)` returns to the list; `state` can ask the list to switch tab
 * (e.g. { activeTab: "shipping_notes" } or { activeScheduleTab: "scheduled" }).
 */
export const PlanShipmentDrawerProvider = ({ children }) => {
  const navigate = useNavigate();
  const closeDrawer = useCallback(
    (state = null) => navigate(PLAN_SHIPMENT_PATH, { replace: true, state }),
    [navigate]
  );
  const value = useMemo(() => ({ embedded: true, closeDrawer }), [closeDrawer]);

  return <PlanShipmentDrawerContext.Provider value={value}>{children}</PlanShipmentDrawerContext.Provider>;
};

export const usePlanShipmentDrawer = () => useContext(PlanShipmentDrawerContext);
